import { useState } from 'react';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Text from '../../elements/text/Text';
import Modal from '../../sections/modal/Modal';

const DeleteNotificationButton = ({ notif, onDelete }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const [modal, setModal] = useState(false);

  const handleOpenModal = () => setModal(true);
  const handleCloseModal = () => setModal(false);
  const handleDelete = () => {
    onDelete(notif.id);
    handleCloseModal();
  };

  return (
    <>
      {isSmallScreen ? (
        <IconButton onClick={handleOpenModal} size="large">
          <DeleteForeverIcon />
        </IconButton>
      ) : (
        <Button
          variant="contained"
          color="error"
          startIcon={<DeleteForeverIcon />}
          onClick={handleOpenModal}
        >
          {t('delete', { ns: 'buttons' })}
        </Button>
      )}
      <Modal
        openModal={modal}
        title={t('monitoring.notifDeleteConfirm', { ns: 'sectionTitles' })}
        showActions
        deleteButton
        handleConfirm={handleDelete}
        handleClose={handleCloseModal}
      >
        <Alert severity="error" sx={{ mb: 2 }}>
          {t('cantUndo', { ns: 'descriptions' })}
        </Alert>
        <Text>
          {t('areYouSure', { ns: 'descriptions', text: 'notification' })}
        </Text>
      </Modal>
    </>
  );
};

DeleteNotificationButton.propTypes = {
  notif: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteNotificationButton;
